import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import TotalReimbursements from "../../../../images/icons/personal-total-reimbursements.svg";
import { calculateTotalReimbursement } from './Services/reportReimbursement';

// Functional component
function TotalReimburesentCard({ reimbursementInv }) {
  const [displayedReimbursement, setDisplayedReimbursement] = useState(0);
  const [targetReimbursement, setTargetReimbursement] = useState(0);
  const animationFrameRef = useRef(null);
  const reportingReimbursment = useSelector((state) => state.reportingReimbursment);
  const { forex } = useSelector((state) => state.forex);
  const settings = JSON.parse(localStorage.getItem("settings"));

  useEffect(() => {
    if (reimbursementInv && reportingReimbursment && settings && settings.currency && forex) {
      const totalReimbursementAmount = calculateTotalReimbursement(reimbursementInv, reportingReimbursment, settings.currency, forex);
      const parsedAmount = parseFloat(totalReimbursementAmount) || 0;
      setTargetReimbursement(parsedAmount);
    } else {
      setTargetReimbursement(0);
    }
  }, [reimbursementInv, reportingReimbursment, settings, forex]);

  useEffect(() => {
    // Cancel any existing animation
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }

    const startValue = displayedReimbursement;
    const endValue = targetReimbursement;
    const duration = 1000; // Animation duration in milliseconds
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function for smooth animation (ease-out)
      const easeOut = 1 - Math.pow(1 - progress, 3);
      
      const currentValue = startValue + (endValue - startValue) * easeOut;
      setDisplayedReimbursement(parseFloat(currentValue.toFixed(2)));

      if (progress < 1) {
        animationFrameRef.current = requestAnimationFrame(animate);
      } else {
        setDisplayedReimbursement(endValue);
        animationFrameRef.current = null;
      }
    };

    if (Math.abs(startValue - endValue) > 0.01) {
      animationFrameRef.current = requestAnimationFrame(animate);
    }

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [targetReimbursement]);

  return (
    <div>
      <div className="overview-item">
        <div className="overview-title-outer">
          <div className="overview-title">Total Reimbursements</div>
          <div className="overview-icon">
            <img src={TotalReimbursements} alt="cLock" />
          </div>
        </div>

        <div className="overview-rice">
          {new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: settings?.currency || "USD",
          }).format(displayedReimbursement)}
        </div>
      </div>
    </div>
  );
}

export default TotalReimburesentCard;
